import { useState } from "react";
import { t, font } from "@realtyflows/ui";

export default function PasswordInput({ label, value, onChange, placeholder }) {
  const [show, setShow] = useState(false);

  return (
    <div>
      {label && <div style={{ fontSize: 11, color: t.textSecondary, marginBottom: 4, fontWeight: 600, fontFamily: font.body }}>{label}</div>}
      <div style={{ position: "relative" }}>
        <input
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{
            width: "100%", boxSizing: "border-box",
            background: t.surfaceWarm, border: `1.5px solid ${t.border}`, borderRadius: 8,
            padding: "10px 40px 10px 12px", color: t.textPrimary, fontSize: 13,
            fontFamily: font.body, outline: "none",
          }}
        />
        <button type="button" onClick={() => setShow(!show)} tabIndex={-1}
          style={{
            position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
            background: "none", border: "none", cursor: "pointer", padding: 4,
            color: t.textMuted, display: "flex", alignItems: "center",
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {show ? (
              <>
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
                <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
              </>
            ) : (
              <>
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </>
            )}
          </svg>
        </button>
      </div>
    </div>
  );
}
